import $http from '../../axios-intance';
import {Notification} from 'element-ui';

/**
 * Obtener conexiones registradas.
 */
export async function fetchConnections({commit}) {
    await $http.get('/api/configuracion-ws-siesa')
        .then((response) => {
            commit('setConnections', response.data);
        })
        .catch((error) => {
            console.error(error);
            Notification.error({
                title: 'Error',
                message: 'Error al obtener las conexiones registradas',
                type: 'error',
                duration: 3000,
                customClass: 'notification-box',
            });
        });
}

/**
 * Crear o actualizar una conexión.
 */
export async function saveConnection({commit, state, dispatch}) {
    const request = state.connection.id
        ? $http.put('/api/configuracion-ws-siesa/' + state.connection.id, state.connection)
        : $http.post('/api/configuracion-ws-siesa', state.connection);

    await request
        .then(async () => {
            commit('setModalShow', false);
            commit('setTestResult', null);
            await dispatch('fetchConnections');
            Notification.success({
                title: 'Éxito!',
                message: 'Conexión guardada exitosamente',
                type: 'success',
                duration: 3000,
                customClass: 'notification-box',
            });
        })
        .catch((error) => {
            console.error(error);
            Notification.error({
                title: 'Error',
                message: error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : 'Error al guardar la conexión',
                type: 'error',
                duration: 3000,
                customClass: 'notification-box',
            });
        });
}

/**
 * Marcar una conexión como activa.
 */
export async function activateConnection({dispatch}, id) {
    await $http.post('/api/configuracion-ws-siesa/' + id + '/activar')
        .then(async () => {
            await dispatch('fetchConnections');
            Notification.success({
                title: 'Éxito!',
                message: 'Conexión activada exitosamente',
                type: 'success',
                duration: 3000,
                customClass: 'notification-box',
            });
        })
        .catch((error) => {
            console.error(error);
            Notification.error({
                title: 'Error',
                message: 'Error al activar la conexión',
                type: 'error',
                duration: 3000,
                customClass: 'notification-box',
            });
        });
}

/**
 * Eliminar una conexión registrada.
 */
export async function deleteConnection({dispatch}, id) {
    await $http.delete('/api/configuracion-ws-siesa/' + id)
        .then(async () => {
            await dispatch('fetchConnections');
            Notification.success({
                title: 'Éxito!',
                message: 'Conexión eliminada exitosamente',
                type: 'success',
                duration: 3000,
                customClass: 'notification-box',
            });
        })
        .catch((error) => {
            Notification.error({
                title: 'Error',
                message: error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : 'Error al eliminar la conexión',
                type: 'error',
                duration: 3000,
                customClass: 'notification-box',
            });
        });
}

/**
 * Probar conectividad hacia una IP:puerto.
 */
export async function testConnection({commit}, ip) {
    commit('setTestingConnection', true);
    commit('setTestResult', null);

    await $http.post('/api/configuracion-ws-siesa/probar-conexion', {ip})
        .then((response) => {
            commit('setTestResult', response.data);
        })
        .catch((error) => {
            commit('setTestResult', {
                success: false,
                message: error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : 'Error al probar la conexión'
            });
        })
        .finally(() => {
            commit('setTestingConnection', false);
        });
}
